import React, { useEffect, useState } from "react";
import RequestOtpForm from "../../loginPage/RequestOtpForServiceVoter/requestOtpForm";
import Footer from "../footer";
import Intro from "../intro";
import "../login.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useChangeMigratedPasswordMutation } from "../../../services/loginservices";
import { useChangePasswordMutation } from "../../../services/User_management/userService";
import { endOfISOWeek } from "date-fns";
import { styles } from "../login/members/member";
import MembersDetails from "../login/members/memberDetails";


function RequestOtp() {
  let navigate = useNavigate();
  const [changepassword , changepassworddata] = useChangePasswordMutation()
  
  const [changeMpassword , changeMpassworddata] = useChangeMigratedPasswordMutation()
  const [exceedError,setExceedError] = useState(false);
  const [resetPassword,setresetPassword] = useState(false);
  const [Error,setError] = useState({});
  const [state,setState]=useState({})
  const location = useLocation()
  const [loginObj, setLoginObj] = useState({
    confirmpassword: "",
    password: "",
    userId: ""
  });

  useEffect(()=>{
    setState(location.state)
  },[])

  const handlesubmit = (e,data) => {
    e.preventDefault();
    let error = {};
    if (!loginObj.confirmpassword || loginObj.confirmpassword === "") {
      error["confirmpassword"] = "This field is required";
    }else if(loginObj.password != loginObj.confirmpassword){
        error["confirmpassword"] = "Password does not match";
      }
    if (!loginObj.password || loginObj.password === "") {
      error["password"] = "This field is required";
    }else if (loginObj.password != "" && !(new RegExp(/^(?=.*[A-Z])(?=.*\d)(?=.*[\W|_])[A-Za-z\d\W_]{8,}$/).test(loginObj.password))){
      error["password"] = "Please enter valid password";
    }

    
    if(localStorage.firstLogin !== "M" )
    {
      if (!loginObj.userId || loginObj.userId === "") {
        error["userId"] = "This field is required";
      }
    }

    if(localStorage.first_role !== "blo")
    {
      delete error["userId"]
    }

    if(Object.keys(error).length){
      setError(error)
      return
    }
    var data = {
      newPassword:loginObj.password,
      confirmNewPassword:loginObj.confirmpassword,
      userId:state?.userId ? state.userId : null,
      userType:"cs",
    }

    var data1 = {
      newPassword:loginObj.password,
      confirmNewPassword:loginObj.confirmpassword,
    }

    // if(localStorage.firstLogin == "M" || localStorage.first_role !="blo") 
    //             // || localStorage.first_role == "aero" )
    // {
    //   changeMpassword(data1);
    // }
    // else{
      changepassword(data);
    // }
  
  };

  useEffect (() => {
    if(changepassworddata.isSuccess  || changeMpassworddata.isSuccess){
      navigate("/login");
    localStorage.clear()
    }
  },[changepassworddata.isSuccess, changeMpassworddata.isSuccess])
 
  return (
    <div style={styles.main}>
                      <div style={styles.row}>
              
                        {/* Left Div - Commissioners */}
                        <MembersDetails></MembersDetails>
                          <div style={styles.boxLogin}>
               <div className="form_login">
                 <form onSubmit={handlesubmit} className="form_align">
                <RequestOtpForm
                  loginObj={loginObj}
                  setLoginObj={setLoginObj}
                  setError={setError}
                  Error={Error}
                  exceedError={exceedError}
                  resetPassword={resetPassword}
                  role = {localStorage.first_role}
                ></RequestOtpForm>
              </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RequestOtp;
